import { useStore } from 'utils/hooks/store';

import { useEditorStore } from 'containers/Tiptap/hooks/useEditorStore';

export function useDefaultFolderId(): string | null {
  const { folders } = useStore();
  const editorStore = useEditorStore();

  const candidates: Array<string | undefined> = [];
  const openDocId = editorStore.currentEntityId;
  if (openDocId) {
    const ancestors = folders.getFolderAncestorsByDocumentUuid(openDocId);
    candidates.push(ancestors[ancestors.length - 1]?.uuid);
  }
  candidates.push(folders.selectedFolderId ?? undefined);

  return candidates.find((id) => id && folders.flatFolders.some((f) => f.uuid === id)) ?? null;
}
